import { StorePaymentMethod } from '../constants/StorePaymentMethod';
import {
  EXPENSE_CATEGORIES,
  EXPENSE_END_MODES,
  EXPENSE_FREQUENCIES,
} from '../constants/Expenses';

export const validateExpenseForm = (form) => {
  const errors = {};

  if (!EXPENSE_CATEGORIES.includes(form?.category)) {
    errors.category = 'expenses.validation.categoryRequired';
  }

  if (!String(form?.description || '').trim()) {
    errors.description = 'expenses.validation.descriptionRequired';
  }

  const amount = Number(form?.amount);
  if (!Number.isFinite(amount) || amount <= 0) {
    errors.amount = 'expenses.validation.amountRequired';
  }

  if (form?.vatAmount !== '' && form?.vatAmount != null) {
    const vatAmount = Number(form.vatAmount);
    if (!Number.isFinite(vatAmount) || vatAmount < 0 || (Number.isFinite(amount) && vatAmount > amount)) {
      errors.vatAmount = 'expenses.validation.vatInvalid';
    }
  }

  if (!form?.expenseDate) {
    errors.expenseDate = 'expenses.validation.dateRequired';
  }

  if (!form?.paymentMethod || form.paymentMethod === StorePaymentMethod.Online) {
    errors.paymentMethod = 'expenses.validation.paymentMethodRequired';
  }

  if (form?.recurring) {
    Object.assign(errors, validateRecurrence(form.recurrence));
  }

  return errors;
};

export const validateRecurrence = (recurrence) => {
  const errors = {};
  const intervalCount = Number(recurrence?.intervalCount);

  if (!EXPENSE_FREQUENCIES.includes(recurrence?.frequency)) {
    errors.frequency = 'expenses.validation.frequencyRequired';
  }

  if (!Number.isInteger(intervalCount) || intervalCount < 1) {
    errors.intervalCount = 'expenses.validation.intervalRequired';
  }

  if (!EXPENSE_END_MODES.includes(recurrence?.endMode)) {
    errors.endMode = 'expenses.validation.endModeRequired';
  }

  if (recurrence?.endMode === 'AfterCount') {
    const occurrenceCount = Number(recurrence?.occurrenceCount);
    if (!Number.isInteger(occurrenceCount) || occurrenceCount < 1) {
      errors.occurrenceCount = 'expenses.validation.occurrenceCountRequired';
    }
  }

  if (recurrence?.endMode === 'OnDate') {
    if (!recurrence?.endDate) {
      errors.endDate = 'expenses.validation.endDateRequired';
    } else if (recurrence?.startDate && recurrence.endDate < recurrence.startDate) {
      errors.endDate = 'expenses.validation.endDateBeforeStart';
    }
  }

  return errors;
};
